/**
 * The fair, flat per-spin odds for the wheel — a standalone leaf module (no router /
 * hono / drizzle imports) so the client can show the odds without pulling the server
 * bundle. The server's OUTCOMES table in router.ts is built from these same weights.
 */
export type OutcomeKind = "+1" | "x2" | "again" | "bust" | "nothing" | "jackpot";

export interface OutcomeWeight {
  kind: OutcomeKind;
  weight: number;
  gaugePercent: number;
  label: string;
}

// FLAT, FAIR: every spin is independent and identical (true random). Weights sum to 100
// so they read as percentages. The odds NEVER shift with streak/history.
export const OUTCOME_WEIGHTS: readonly OutcomeWeight[] = [
  { kind: "+1", weight: 50, gaugePercent: 50, label: "+1" },
  { kind: "bust", weight: 25, gaugePercent: 8, label: "BUST" },
  { kind: "x2", weight: 14, gaugePercent: 78, label: "DOUBLED" },
  { kind: "nothing", weight: 5, gaugePercent: 28, label: "whiff" },
  { kind: "jackpot", weight: 4, gaugePercent: 99, label: "x3!! JACKPOT" },
  { kind: "again", weight: 2, gaugePercent: 60, label: "spin again" },
];

export const TOTAL_WEIGHT = OUTCOME_WEIGHTS.reduce((s, o) => s + o.weight, 0);

/** Public odds table (kind → percent) — for showing players the wheel is fair. */
export const ODDS: ReadonlyArray<{ kind: OutcomeKind; percent: number }> =
  OUTCOME_WEIGHTS.map((o) => ({
    kind: o.kind,
    percent: Math.round((o.weight / TOTAL_WEIGHT) * 100),
  }));
